import { Value } from 'theme/style'

const style = {
  paper: {
    borderRadius: Value.BorderRadius_Field + '! important',
  },
}

export default style
